module.exports = __webpack_public_path__ + "img/marker.f047e87c.png";